(function () {
  if (window.__productInstallmentListInit) return;
  window.__productInstallmentListInit = true;

  var paypalRefreshTimers = Object.create(null);

  function getPayPalConfig() {
    return window.__productInstallmentPayPalConfig || null;
  }

  function getPayPalSdkSrc() {
    var config = getPayPalConfig();
    return config && config.sdkSrc ? config.sdkSrc : null;
  }

  function getPayPalNamespace() {
    var config = getPayPalConfig();
    return (config && config.namespace) || 'PayPalSDK';
  }

  function toArray(nodes) {
    return Array.prototype.slice.call(nodes || []);
  }

  function getPayPalApi() {
    if (typeof window.PayPalSDK !== 'undefined' && window.PayPalSDK.Messages) {
      return window.PayPalSDK;
    }
    if (typeof window.paypal !== 'undefined' && window.paypal.Messages) {
      return window.paypal;
    }
    return null;
  }

  function parsePayPalAmount(raw) {
    if (raw == null || raw === '') return null;
    var normalized = String(raw).replace(/,/g, '').trim();
    var amount = parseFloat(normalized);
    if (!Number.isFinite(amount) || amount <= 0) return null;
    return amount.toFixed(2);
  }

  function getRefreshScopeKey(root) {
    if (!root || root === document) return 'document';
    if (root.id) return root.id;
    if (root.getAttribute && root.getAttribute('data-product-installment-list')) {
      return 'list-' + (root.dataset.ppRefreshKey || 'anonymous');
    }
    return 'scope-' + (root.className || 'node');
  }

  function markPayPalReady(el) {
    if (!el) return;
    el.classList.remove('is-rendering');
    el.classList.add('is-ready');
  }

  function markPayPalRendering(el) {
    if (!el) return;
    el.classList.remove('is-ready');
    el.classList.add('is-rendering');
  }

  function dedupePayPalContainer(el) {
    if (!el) return;
    var iframes = el.querySelectorAll('iframe');
    if (iframes.length <= 1) return;

    for (var i = iframes.length - 1; i >= 1; i--) {
      var frame = iframes[i];
      var parent = frame.parentNode;
      if (parent === el) {
        parent.removeChild(frame);
      } else if (parent) {
        parent.remove();
      }
    }
  }

  function hasPayPalContent(el) {
    return !!(el && (el.querySelector('iframe') || el.childElementCount > 0));
  }

  function isPayPalMessageRendered(el, amount) {
    if (!el || !amount) return false;
    if (el.dataset.ppRenderedAmount !== amount) return false;
    return hasPayPalContent(el);
  }

  function needsPayPalRender(el, force) {
    if (!el) return false;
    var amount = parsePayPalAmount(el.getAttribute('data-pp-amount'));
    if (!amount) return false;
    if (force) return true;
    return !isPayPalMessageRendered(el, amount);
  }

  function watchPayPalMount(el, amount) {
    var attempts = 0;
    var timer = window.setInterval(function () {
      attempts += 1;
      if (hasPayPalContent(el)) {
        el.dataset.ppRenderedAmount = amount;
        dedupePayPalContainer(el);
        markPayPalReady(el);
        window.clearInterval(timer);
        return;
      }
      if (attempts >= 24) {
        window.clearInterval(timer);
        markPayPalReady(el);
      }
    }, 125);
  }

  function ensurePayPalSdk(callback) {
    if (typeof callback !== 'function') return;

    if (getPayPalApi()) {
      callback();
      return;
    }

    if (window.__paypalInstallmentSdkLoading) {
      window.__paypalInstallmentSdkQueue = window.__paypalInstallmentSdkQueue || [];
      window.__paypalInstallmentSdkQueue.push(callback);
      return;
    }

    var sdkSrc = getPayPalSdkSrc();
    if (!sdkSrc) return;

    window.__paypalInstallmentSdkLoading = true;
    window.__paypalInstallmentSdkQueue = [callback];

    var script = document.createElement('script');
    script.src = sdkSrc;
    script.setAttribute('data-namespace', getPayPalNamespace());
    script.async = true;
    script.onload = function () {
      window.__paypalInstallmentSdkLoading = false;
      var queue = window.__paypalInstallmentSdkQueue || [];
      window.__paypalInstallmentSdkQueue = [];
      queue.forEach(function (cb) {
        try {
          cb();
        } catch (e) {}
      });
    };
    script.onerror = function () {
      window.__paypalInstallmentSdkLoading = false;
      window.__paypalInstallmentSdkQueue = [];
    };
    document.head.appendChild(script);
  }

  function renderPayPalMessage(el, options) {
    options = options || {};
    var paypalApi = getPayPalApi();
    if (!el || !paypalApi) return false;

    var amount = parsePayPalAmount(el.getAttribute('data-pp-amount'));
    if (!amount) return false;

    if (!options.force && isPayPalMessageRendered(el, amount)) {
      dedupePayPalContainer(el);
      markPayPalReady(el);
      return true;
    }

    if (el.dataset.ppRenderPending === amount) {
      return false;
    }

    el.dataset.ppRenderPending = amount;

    var amountChanged = el.dataset.ppRenderedAmount && el.dataset.ppRenderedAmount !== amount;
    if (amountChanged) {
      markPayPalRendering(el);
      if (el.childElementCount > 0) {
        el.innerHTML = '';
      }
    }

    try {
      paypalApi.Messages({ amount: amount }).render(el);
      el.dataset.ppRenderedAmount = amount;
      delete el.dataset.ppRenderPending;
      dedupePayPalContainer(el);
      watchPayPalMount(el, amount);
      return true;
    } catch (e) {
      delete el.dataset.ppRenderPending;
      markPayPalReady(el);
      return false;
    }
  }

  function isInHiddenInstallmentPanel(el) {
    var panel = el && el.closest ? el.closest('[data-product-installment-panel]') : null;
    return !!(panel && panel.hidden);
  }

  function collectPayPalMessages(root, filterFn, options) {
    options = options || {};
    var scope = root && root.querySelectorAll ? root : document;
    return toArray(scope.querySelectorAll('[data-pp-message]')).filter(function (el) {
      if (!options.includeHiddenPanel && isInHiddenInstallmentPanel(el)) {
        return false;
      }
      return filterFn(el);
    });
  }

  function getPanelPayPalMessages(list) {
    var panel = list && list.querySelector('[data-product-installment-panel]');
    if (!panel) return [];
    return toArray(panel.querySelectorAll('[data-pp-message][data-pp-mount="panel"]')).filter(function (el) {
      return needsPayPalRender(el, false);
    });
  }

  function refreshPanelPayPalMessages(list) {
    if (!list) return;
    var panel = list.querySelector('[data-product-installment-panel]');
    if (!panel || panel.hidden) return;

    var panelPaypal = getPanelPayPalMessages(list);
    if (!panelPaypal.length) return;

    ensurePayPalSdk(function () {
      panelPaypal.forEach(function (el) {
        renderPayPalMessage(el);
      });
    });
  }

  function schedulePanelPayPalOnExpand(list) {
    refreshPanelPayPalMessages(list);
    window.setTimeout(function () {
      refreshPanelPayPalMessages(list);
    }, 350);
  }

  function refreshPayPalMessages(root, options) {
    options = options || {};
    var messages = collectPayPalMessages(
      root,
      function (el) {
        return needsPayPalRender(el, options.force);
      },
      { includeHiddenPanel: !!options.includeHiddenPanel }
    );
    if (!messages.length) return;

    ensurePayPalSdk(function () {
      messages.forEach(function (el) {
        renderPayPalMessage(el, options);
      });
    });
  }

  function schedulePayPalRefresh(root, delayMs) {
    var key = getRefreshScopeKey(root);
    window.clearTimeout(paypalRefreshTimers[key]);

    paypalRefreshTimers[key] = window.setTimeout(function () {
      delete paypalRefreshTimers[key];
      refreshPayPalMessages(root);

      window.setTimeout(function () {
        var pending = collectPayPalMessages(
          root,
          function (el) {
            return needsPayPalRender(el, false);
          },
          { includeHiddenPanel: false }
        );
        if (!pending.length) return;

        ensurePayPalSdk(function () {
          pending.forEach(function (el) {
            renderPayPalMessage(el);
          });
        });
      }, 600);
    }, typeof delayMs === 'number' ? delayMs : 80);
  }

  function initInstallmentListsOnly(root) {
    var scope = root && root.querySelectorAll ? root : document;
    toArray(scope.querySelectorAll('[data-product-installment-list]')).forEach(function (list, index) {
      if (!list.dataset.ppRefreshKey) {
        list.dataset.ppRefreshKey = String(Date.now()) + '-' + index;
      }
      initInstallmentList(list);
    });
  }

  function openShopPayModal(list) {
    if (!list) return;
    var paymentTerms = list.querySelector('shopify-payment-terms');
    if (!paymentTerms || !paymentTerms.shadowRoot) return;

    var cta = paymentTerms.shadowRoot.querySelector('#shopify-installments-cta');
    if (cta) cta.click();
  }

  function initInstallmentList(list) {
    if (!list || list.__productInstallmentListBound) return;
    list.__productInstallmentListBound = true;

    var toggle = list.querySelector('[data-product-installment-toggle]');
    var panel = list.querySelector('[data-product-installment-panel]');
    if (!toggle || !panel) return;

    function shouldSkipToggle(target) {
      if (!target || !target.closest) return false;
      return !!target.closest(
        '.productInstallmentList__summaryProvider, .productInstallmentList__providerMount, shopify-payment-terms, klarna-placement, .affirm-as-low-as, afterpay-placement, [data-pp-message]'
      );
    }

    function handleToggle() {
      var expanded = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', expanded ? 'false' : 'true');
      panel.hidden = expanded;

      if (!expanded) {
        window.requestAnimationFrame(function () {
          window.requestAnimationFrame(function () {
            schedulePanelPayPalOnExpand(list);
          });
        });
      }
    }

    toggle.addEventListener('click', function (event) {
      if (shouldSkipToggle(event.target)) return;
      handleToggle();
    });
    toggle.addEventListener('keydown', function (event) {
      if (event.key !== 'Enter' && event.key !== ' ') return;
      if (shouldSkipToggle(event.target)) return;
      event.preventDefault();
      handleToggle();
    });

    list.addEventListener('click', function (event) {
      var trigger = event.target.closest('[data-shop-pay-trigger]');
      if (!trigger) return;

      event.preventDefault();

      openShopPayModal(list);

      window.setTimeout(function () {
        openShopPayModal(list);
      }, 400);
    });

    [0, 300, 1000].forEach(function (delay) {
      window.setTimeout(function () {
        var termsHolder = list.querySelector('.productInstallmentList__termsHolder');
        var hasTerms = !!(termsHolder && termsHolder.querySelector('shopify-payment-terms'));
        if (!hasTerms) {
          list.classList.add('is-shop-pay-pending');
        } else {
          list.classList.remove('is-shop-pay-pending');
        }
      }, delay);
    });
  }

  function initAll(root) {
    var scope = root && root.querySelectorAll ? root : document;
    initInstallmentListsOnly(scope);
    schedulePayPalRefresh(scope, 80);
  }

  window.ProductInstallmentList = {
    refreshPayPalMessages: refreshPayPalMessages,
    schedulePayPalRefresh: schedulePayPalRefresh
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });

  document.addEventListener('cart:updated', function (event) {
    var root = event && event.detail && event.detail.root;
    var scope = root || document.getElementById('halo-cart-sidebar') || document;
    initInstallmentListsOnly(scope);
    schedulePayPalRefresh(scope, 120);
  });
})();
